import React from "react";

// Link-only field (e.g. "What is your website link?"). Same URL pattern the
// legacy Questionnaire1.js uses (isValidUrl). Stores the raw string; shows a
// gentle inline hint when the value is present but not a valid URL.
const URL_PATTERN = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;

export const LinkField = ({ question, value, onChange, lang }) => {
  const v = value || "";
  const invalid = v.trim() !== "" && !URL_PATTERN.test(v.trim());
  return (
    <div>
      <input
        type="url"
        inputMode="url"
        className="dq-input"
        placeholder={
          lang === "ar"
            ? question.placeholder_arabic || "https://example.com"
            : question.placeholder || "https://example.com"
        }
        value={v}
        onChange={(e) => onChange(e.target.value)}
        dir="ltr"
      />
      {invalid && (
        <p className="dq-error" style={{ color: "#D83D99", marginTop: 4, fontSize: 13 }}>
          {lang === "ar" ? "الرجاء إدخال رابط صالح" : "Please enter a valid link"}
        </p>
      )}
    </div>
  );
};
